import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PreparationLogo } from '../assets/images/web-isn';
import { useTranslation } from 'react-i18next';

const PreparationPage = () => {
  const { t } = useTranslation();
  const { language } = useParams();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="d-flex flex-column justify-content-center preparation-page">
        <img src={PreparationLogo} alt="preparation-logo" />
        <span className="preparation-page__title mt-4">{t('preparation.title')}</span>
        <span className="preparation-page__disc mt-4">{t('preparation.message')}</span>
        <Link to={`/${language}`}>
          <div className="text-center mt-4">
            <input className="btn-gohome" type="button" value={t('preparation.btn_gohome')} />
          </div>
        </Link>
      </div>
    </>
  );
};

export { PreparationPage };
